module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp12_9006.35be9cc9.png";